<template>
    <div class="form-wrapper">
        <PanelInput v-model="localForm.name" :label="$t('name')" :placeholder="$t('enterName')" :max-length="40" :disabled="isPowerApps || isRestricted || isAllowList || isProhibited" :tooltip="$t('tooltips.appGroup.name')" />
        <PanelInput v-model="localForm.description" :label="$t('description')" :placeholder="$t('enterDescription')" :max-length="1001" :disabled="isPowerApps" :tooltip="$t('tooltips.appGroup.description')"/>
        <PanelDropdown v-model="localForm.audit" :label="$t('audit2')" :options="auditOptions" placeholder="" :tooltip="$t('tooltips.appGroup.audit')" :disabled="isRestricted || isAllowList || isProhibited"/>
        <div class="d-flex ">
            <div class="d-flex col-4" style="padding-left: 0 !important;">
                <label class="form-label ">{{ $t('childProcess') }}</label>
                <Tooltip :text="$t('tooltips.appGroup.childProcess')">
                    <i class="ag-icon ag-icon_table_info small info-icon"></i>
                </Tooltip>
            </div>
            <div class="col-8" >
                <ToggleSwitch v-model="localForm.childProcess" label="" :show-info="false" :child-process="true" :disabled="isPowerApps || isProhibited"  />
            </div>
        </div>
        <PanelCheckBoxGroup v-model="localForm.memorySecurity" :label="$t('memorySecurity')" :options="memoriesOptions" :disabled="isPowerApps || isRestricted || isAllowList || isProhibited" :tooltip="$t('tooltips.appGroup.memorySecurity')" />
        <PanelCheckBoxGroup v-model="localForm.inheritance" :label="$t('inheritance')" :options="inheritanceOptions" :disabled="isPowerApps || isProhibited" :tooltip="$t('tooltips.appGroup.inheritance')" />
        <PanelCheckBoxGroup v-model="localForm.subsystemsInDiscoveryMode" :label="$t('discoveryMode')" :options="realOptions" :tooltip="$t('tooltips.appGroup.discoveryMode')" />
        <ExpertNotes v-model="localForm.expertNotes" :max-length="1000" :label="$t('expertNotes')" />
    </div>
</template>

<script setup>
import { defineProps, ref, defineEmits, watch, computed } from 'vue'
import PanelInput from './components/panelInput.vue'
import PanelDropdown from './components/panelDropdown.vue'
import PanelCheckBoxGroup from './components/panelCheckBoxGroup.vue'
import { useStore } from "@/store";
import { AppGroupTypes } from '@/helpers/enums/AppGroupTypes';
import ExpertNotes from './components/expertNotes.vue';
import Tooltip from './components/tooltip.vue'
import ToggleSwitch from './components/toggle-switch.vue'
const store = useStore();
const props = defineProps({
    form: {
        type: Object,
        required: true,
    },
    modelValue: {
        type: Object,
        required: true,
    },
    row: Object,
    formType: {
        type: String,
        default: 'appGroup'
    }
})
const emit = defineEmits(['update:form', 'update:modelValue'])
const memoriesOptions = computed(() => store.state.general.enums['MemorySecurity'] || [])
const inheritanceOptions = computed(() => store.state.general.enums['Inheritance'] || [])
const auditOptions = computed(() => store.state.general.enums['AppGroupAudit'] || [])
const discoveryOptions = computed(() => store.state.general.enums['DiscoveryMode'] || [])

const realOptions = computed(() => {
  if (isRestricted.value || isAllowList.value || isProhibited.value) {
    return discoveryOptions.value.filter((opt) =>
      ["Process Start"].includes(opt.label)
    );
  }
  if (isPowerApps.value) {
    return discoveryOptions.value.filter((opt) =>
      ["Process Start", "Code Load", "Memory"].includes(opt.label)
    );
  }
  return discoveryOptions.value.filter((opt) => opt.label !== "Enable All" && String(opt.label).toLowerCase() !== 'none');
})

const localForm = computed({
    get() {
        return props.form;
    },
    set(newVal) {
        emit('update:form', newVal);
    }
});

const isPowerApps = computed(() => (Number(localForm.value?.appGroupType)) === AppGroupTypes.PowerApps);
const isRestricted = computed(() => Number(localForm.value?.appGroupType) === AppGroupTypes.Restricted)
const isAllowList = computed(() => Number(localForm.value?.appGroupType) === AppGroupTypes.AllowList)
const isProhibited = computed(() => Number(localForm.value?.appGroupType) === AppGroupTypes.Prohibited)
// Inheritance bit flags
const ENFORCE = 1; 
const CHILD = 2;   


watch(
  () => Number(localForm.value?.inheritance || 0),
  (newMask, oldMask) => {
    const prevHasEnforce = (Number(oldMask) & ENFORCE) === ENFORCE;
    const prevHasChild = (Number(oldMask) & CHILD) === CHILD;
    const hasEnforce = (Number(newMask) & ENFORCE) === ENFORCE;
    const hasChild = (Number(newMask) & CHILD) === CHILD;

    if (!prevHasChild && hasChild && !hasEnforce) {
      localForm.value.inheritance = Number(newMask) | ENFORCE;
      return;
    }

    if (prevHasEnforce && !hasEnforce && hasChild) {
      localForm.value.inheritance = Number(newMask) & ~CHILD;
      return;
    }
  }
)
</script>
<style>
.form-wrapper {
    font-size: 0.8rem !important;
    padding-left: 1rem;
    padding-right: 1rem;
}

.custom-input {
    width: inherit;
}

.label-check {
    margin-left: 5px;
    margin-bottom: 0px !important;
}

.form-label {
    color: #164B6C;
    font-weight: bold;
    margin-left: 0 !important;
}

.info-icon {
    margin-left: 3px;
}

.p-dropdown-panel {
    z-index: 9999 !important;
}
</style>
